/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} History_Transfer_Export_FailedInputs */

const en_us2_history_transfer_export_failed = /** @type {(inputs: History_Transfer_Export_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The file could not be made. Try again.`)
};

const pt_br2_history_transfer_export_failed = /** @type {(inputs: History_Transfer_Export_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não deu para gerar o arquivo. Tente de novo.`)
};

const es_419_history_transfer_export_failed = /** @type {(inputs: History_Transfer_Export_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo generar el archivo. Inténtalo de nuevo.`)
};

const pt_pt2_history_transfer_export_failed = /** @type {(inputs: History_Transfer_Export_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não foi possível gerar o ficheiro. Tenta outra vez.`)
};

const fr_fr2_history_transfer_export_failed = /** @type {(inputs: History_Transfer_Export_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossible de créer le fichier. Réessaie.`)
};

const de_de2_history_transfer_export_failed = /** @type {(inputs: History_Transfer_Export_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Datei konnte nicht erstellt werden. Versuch es noch mal.`)
};

const it_it2_history_transfer_export_failed = /** @type {(inputs: History_Transfer_Export_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non è stato possibile creare il file. Riprova.`)
};

/**
* | output |
* | --- |
* | "The file could not be made. Try again." |
*
* @param {History_Transfer_Export_FailedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const history_transfer_export_failed = /** @type {((inputs?: History_Transfer_Export_FailedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<History_Transfer_Export_FailedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_history_transfer_export_failed(inputs)
	if (locale === "es-419") return es_419_history_transfer_export_failed(inputs)
	if (locale === "pt-PT") return pt_pt2_history_transfer_export_failed(inputs)
	if (locale === "fr-FR") return fr_fr2_history_transfer_export_failed(inputs)
	if (locale === "de-DE") return de_de2_history_transfer_export_failed(inputs)
	if (locale === "it-IT") return it_it2_history_transfer_export_failed(inputs)
	return en_us2_history_transfer_export_failed(inputs)
});
export { history_transfer_export_failed as "history-transfer.export_failed" }